import userStats from './helpers/userStats';

export class SoundsNav {
  constructor() {
    // start tracking stats when the dom is ready
    document.addEventListener('DOMContentLoaded', () => {
      // the links we want to track stats for
      this.trackableLinks = document.querySelectorAll('[data-sn-trackable]');
      this.trackAnalytics();
    });
  }

  handleLinkClick(link) {
    const { fireEvent } = userStats;
    // get the values for the stats
    const contentType = link.getAttribute('data-content-type');
    const contentLabel = link.getAttribute('data-content-label');

    fireEvent({
      container: contentType,
      actionName: contentLabel,
      actionType: 'select'
    });
  }

  trackAnalytics() {
    // loop through the links and attach click handlers
    // for sending stats
    this.trackableLinks.forEach(link => {
      if (link) {
        link.addEventListener('click', () => this.handleLinkClick(link));
      }
    });
  }

}
